import React from 'react';

const FormLayout = ({ title, description, icon, children, footer, loading }) => {
    return (
        <div className="max-w-4xl mx-auto my-10 bg-white rounded-3xl shadow-2xl border border-gray-100 overflow-hidden animate-fadeIn">
            {/* Encabezado en Gris Oscuro / Antracita */}
            <div className="bg-gradient-to-r from-gray-700 to-gray-800 p-8 text-white relative">
                <div className="relative z-10">
                    <h2 className="text-3xl font-extrabold flex items-center gap-3">
                        {icon && <i className={`bi bi-${icon}`}></i>}
                        {title}
                    </h2>
                    {description && <p className="text-gray-300 mt-2 opacity-90">{description}</p>}
                </div>
                <div className="absolute top-0 right-0 p-4 opacity-10">
                    <i className={`bi bi-${icon} text-9xl text-white`}></i>
                </div>
            </div>

            {/* Cuerpo con fondo blanco puro */}
            <div className={`p-8 bg-white ${loading ? 'opacity-50 pointer-events-none' : ''} transition-opacity`}>
                {children}
            </div>

            {/* Footer en gris muy claro para contraste sutil */}
            {footer && (
                <div className="bg-gray-50 p-6 border-t border-gray-100 flex justify-end gap-4">
                    {footer}
                </div>
            )}
        </div>
    );
};

export default FormLayout;